import * as Constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action = {}) {
    switch(action.type) {
	    case Constants.CLOSE_POPUP:
	        return Object.assign(action);
	    case Constants.OPEN_HELP_POPUP:
	        return Object.assign(action);
	    case Constants.CLOSE_THIS_TASK:
	        return Object.assign(action);
	    case Constants.MOVE_FORWARD:
	        return Object.assign(action);
	    case Constants.MOVE_BACKWARD:
	        return Object.assign(action);
	    case Constants.HOTKEYS_START:
	        return Object.assign(action);
	    case Constants.CHANGE_SEARCH_TEXT:
	        return Object.assign(action);
	    default:
	        return Object.assign(action);
    }
}
